<template>
    <b-card class="project-card" no-body
            @click="onOpenNewProject"
            @keypress.enter.space="onOpenNewProject"
            role="button" tabindex="0" :aria-label="label">
        <div class="project-card-body">
            <b-card-img :src="getImage" :alt="altImage"/>
            <b-card-text>{{text}}</b-card-text>
        </div>
    </b-card>
</template>

<script>
    export default {
        props: {
            text: String,
            label: String,
            image: String,
            url: String
        },
        computed: {
            getImage() {
                return require('../../Images/' + this.image)
            },
            altImage() {
                return this.label + " image";
            },
        },
        methods: {
            onOpenNewProject() {
                if (!this.url) {
                    return false
                }
                this.$router.push({name: this.url})
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    .project-card
        border 0

        &-body
            padding 4px

            .card-text
                padding-top 8px
                font font-sourcesans-semibold
                font-size 14px
                letter-spacing 0
                color color-4
                cursor pointer
                text-align center

            .card-img
                border-radius 10px 10px 10px 10px
                +for_breakpoint(lg xl)
                    height 135.5px
</style>
